import { CAMPAIGN_DEMAND_SOURCES } from '../constants/campaign';

export const parseCommaSeparatedIds = (value = '') =>
  String(value).split(',').map((v) => v.trim()).filter(Boolean);

const parseNumericIds = (value = '') => parseCommaSeparatedIds(value).map(Number);

const HEX_32 = /^[0-9a-f]{32}$/i;

const numericIdConfig = {
  parse: parseNumericIds,
  isValid: Number.isInteger,
  error: 'Target Campaign IDs are required. Campaign IDs must be integers.',
};

export const CAMPAIGN_ID_CONFIG = {
  [CAMPAIGN_DEMAND_SOURCES.PORTAL]: numericIdConfig,
  [CAMPAIGN_DEMAND_SOURCES.DTADS]: numericIdConfig,
  [CAMPAIGN_DEMAND_SOURCES.DTBIDDER]: {
    parse: parseCommaSeparatedIds,
    isValid: (id) => HEX_32.test(id),
    error: 'Target Campaign UUIDs are required. DT Bidder campaign UUIDs must be 32-character hex strings (no hyphens).',
  },
};
